import { Sport } from 'interfaces/sportsbook-data-levels';

export const filterSportDataByGameStartTsRange = (
  data: Record<string, Sport>,
  timestampRange: {
    '@gt': number;
    '@lt': number;
  }
): Record<string, Sport> => {
  // Copy the original data
  const filteredData = JSON.parse(JSON.stringify(data));

  for (const sportId in filteredData) {
    const sport = filteredData[sportId];
    let hasRegionInSport = false;

    // Iterate through regions
    for (const regionId in sport.region) {
      const region = sport.region[regionId];
      let hasCompetitionInRegion = false;

      // Iterate through competitions in the region
      for (const competitionId in region.competition) {
        const competition = region.competition[competitionId];
        let hasGameInCompetition = false;

        // Iterate through games in the competition
        for (const gameId in competition.game) {
          const game = competition.game[gameId];

          // Check if game timestamp falls within the range
          if (
            game.start_ts >= timestampRange['@gt'] &&
            game.start_ts <= timestampRange['@lt']
          ) {
            // Keep the game
            filteredData[sportId].region[regionId].competition[
              competitionId
            ].game[gameId] = game;
            hasGameInCompetition = true;
          } else {
            // Remove the game if it's outside the range
            delete filteredData[sportId].region[regionId].competition[
              competitionId
            ].game[gameId];
          }
        }

        // Remove the competition if it has no games within the range
        if (!hasGameInCompetition) {
          delete filteredData[sportId].region[regionId].competition[
            competitionId
          ];
        } else {
          hasCompetitionInRegion = true;
        }
      }

      // Remove the region if it has no competitions left
      if (!hasCompetitionInRegion) {
        delete filteredData[sportId].region[regionId];
      } else {
        hasRegionInSport = true;
      }
    }

    // Remove the sport if it has no regions left
    if (!hasRegionInSport) {
      delete filteredData[sportId];
    }
  }

  return filteredData;
};
